var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_shape_style_interface = function () {
    OCS.Viewer.Interfaces.OlShapeStyle = {
        options: {
            layer_style_ops: {mask: false},
            shape_style_type_text: 'shape',
            shape_style_ops: {
                fill_color: 'rgba(255, 255, 255, 0.2)',
                stroke_color: 'rgba(90, 90, 90, 0.9)',
                stroke_width: 2,
                text: {
                    font_size: '16px',
                    font_family: 'helvetica,arial,sans-serif',
                }
            }
        },
        ok_outline_style: OCS.Viewer.Config.ok_outline_style,
        get_shape_layer_style_method: function () {
            var style = this.ok_outline_style;

            var defaultStyle = null;

            //TODO: reimplement this to use the mask boolean field
            if (this.options.layer_style_ops.mask) {
                defaultStyle = [new ol.style.Style({
                        fill: new ol.style.Fill({
                            color: '#E3E2E2'
                        }),
                        stroke: new ol.style.Stroke({
                            color: '#000000',
                            width: 1,
                            opacity: 0

                        })
                    })];
            } else {
                var color = OCS.Viewer.Live.Utilities.hex2rgb(style.fillColor);
                defaultStyle = [new ol.style.Style({
                        fill: new ol.style.Fill({
                            color: 'rgba(' + color.red + ',' + color.green + ',' + color.blue + ',' + style.fillOpacity + ')'
                        }),
                        stroke: new ol.style.Stroke({
                            color: style.strokeColor,
                            width: style.strokeWidth,
                            opacity: style.strokeOpacity
                        })
                    })];
            }
            return defaultStyle;
        }
    }; // End OCS.Viewer.Interfaces.OlShapeStyle
};
OCS.Viewer.Functions.define_ol_shape_style_interface();